import React from "react";
import Svg, { Path, Circle } from "react-native-svg";

const RightArrow = ({
  fill = "#E40046",
  stroke = "#E40046",
  scaleX = 1,
  scaleY = 1,
  ...props
}) => (
  <Svg
    width="6"
    height="11"
    viewBox="0 0 6 11"
    fill="none"
    scaleX={scaleX}
    scaleY={scaleY}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M5.62719 5.0109L5.62727 5.01098C5.72572 5.11274 5.78016 5.24952 5.78016 5.39101C5.78016 5.53219 5.72603 5.6692 5.62719 5.7711L5.62719 5.0109ZM5.62719 5.0109L1.70462 0.960883L1.70458 0.960841C1.49733 0.746975 1.15888 0.7474 0.952085 0.961898L0.95204 0.961944C0.749031 1.17265 0.749591 1.51109 0.953061 1.72118L0.953065 1.72119L4.50738 5.391L0.952935 9.06081L0.95291 9.06083C0.749481 9.27094 0.748921 9.60922 0.951889 9.81993L0.951952 9.82C1.05468 9.92655 1.19124 9.98125 1.32877 9.98125C1.4659 9.98125 1.60197 9.92692 1.70457 9.82105L1.70461 9.82101L5.62703 5.77127L5.62719 5.0109Z"
      fill={fill}
      stroke={stroke}
      stroke-width="0.4"
    />
  </Svg>
);

export default RightArrow;
